import React from 'react';
import styleable from 'react-styleable';
import css from './participation.scss';
import ConnectedAllClasses from './all-classes/all-classes';
import ConnectedStudent from './student/student';
import ConnectedSubHeading from '../../components/sub-heading/sub-heading';
import ConnectedSingleClass from './single-class/single-class';
import ConnectedReportRoutes from '../report-routes/report-routes';
import EmptyState from '../../components/empty-state/empty-state';
import EMPTY_STATE_VARIANTS from '../../components/empty-state/empty-state-constants';

const Participation = () => {
    const routeComps = {
        allClasses: ConnectedAllClasses,
        singleClass: ConnectedSingleClass,
        student: ConnectedStudent
    };

    return (
        <div className={css.component}>
            <EmptyState variant={EMPTY_STATE_VARIANTS.NO_STUDENTS}>
                <ConnectedReportRoutes components={routeComps}>
                    <ConnectedSubHeading
                        isExportEnabled
                        isParticipationReport
                    />
                    <div className={css['report-container']} />
                </ConnectedReportRoutes>
            </EmptyState>
        </div>
    );
};

export default styleable(css)(Participation);



// WEBPACK FOOTER //
// ./containers/participation/participation.js